var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSale(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 68,
    viewBox: "0 0 69 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.407 20.246C12.4866 19.3704 13.2208 18.7 14.1 18.7H54.9C55.7792 18.7 56.5134 19.3704 56.593 20.246L59.993 57.646C60.0363 58.1217 59.8774 58.5936 59.5553 58.9463C59.2332 59.299 58.7776 59.5 58.3 59.5H10.7C10.2224 59.5 9.76677 59.299 9.44469 58.9463C9.1226 58.5936 8.96374 58.1217 9.00699 57.646L12.407 20.246ZM15.6525 22.1L12.5616 56.0999H56.4384L53.3475 22.1H15.6525Z",
    fill: "#33CCBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4527 10.4464C29.6611 11.5773 29.4 12.9245 29.4 13.6001V27.2001C29.4 28.139 28.6389 28.9001 27.7 28.9001C26.7611 28.9001 26 28.139 26 27.2001V13.6001C26 12.3329 26.4189 10.2801 27.6673 8.49664C28.978 6.62415 31.1792 5.1001 34.5 5.1001C37.8208 5.1001 40.022 6.62415 41.3327 8.49664C42.5811 10.2801 43 12.3329 43 13.6001V27.2001C43 28.139 42.2389 28.9001 41.3 28.9001C40.3611 28.9001 39.6 28.139 39.6 27.2001V13.6001C39.6 12.9245 39.3389 11.5773 38.5473 10.4464C37.818 9.40462 36.6192 8.5001 34.5 8.5001C32.3808 8.5001 31.182 9.40462 30.4527 10.4464Z",
    fill: "#33CCBD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSale);
export default __webpack_public_path__ + "static/media/Sale.2a75b2f8dad6ac1d271062dafc00d016.svg";
export { ForwardRef as ReactComponent };